import type * as React from 'react';
import { useTranslation } from 'react-i18next';
import ContentLayout from '@cloudscape-design/components/content-layout';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { NotificationPrefsCard } from '@/features/settings/NotificationPrefsCard';

/**
 * Tela "Notificações de operação" (/settings/notifications). Cada super-admin
 * configura, por evento de negócio, os canais e-mail e push de forma
 * independente. O card faz toda a leitura/escrita em
 * `/adminNotificationPrefs/{uid}`.
 *
 * Origem: sem issue — commit c1d548e4c, 2026-06-19 (preferências de
 * notificação de ops por super-admin).
 *
 * Usado por: rota `settings/notifications` (`routes/router.tsx`), menu
 * Sistema (`AdminLayout`). Spec: `docs/screens/admin-notification-prefs.md`.
 * Quem lê as preferências é o `notifyAdmins` das Functions
 * (`apps/functions/src/lib/adminNotify.ts`).
 */
export function NotificationPrefsPage(): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <ContentLayout
      header={
        <Header variant="h1" description={t('admin.notificationPrefs.subtitle')}>
          {t('admin.notificationPrefs.title')}
        </Header>
      }
    >
      <SpaceBetween size="l">
        <NotificationPrefsCard />
      </SpaceBetween>
    </ContentLayout>
  );
}
